export const FINANCIERS = 'FINANCIERS';
export const PROVINCIES = 'PROVINCIES';

export function getFinanciers(financiers) {
    return {type: FINANCIERS, financiers}
}

export function getProvincies(provincies) {
    return {type: PROVINCIES, provincies}
}